import React, { useState, useRef } from "react";
import { useForm } from "react-hook-form";
import toastr from "../../../utils/toast";
import { useOutletContext } from "react-router-dom";

function ConsentModal({ onClose, candidate_id }) {
  const [image, setImage] = useState(null);
  const pasteRef = useRef(null);
  const { setGlobalLoading, token } = useOutletContext();

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm();

  const handlePaste = (e) => {
    const items = e.clipboardData.items;

    for (let item of items) {
      if (item.type.startsWith("image/")) {
        const file = item.getAsFile();
        const reader = new FileReader();

        reader.onload = (event) => {
          setImage(event.target.result);
          setValue("proof_of_consent", event.target.result);
        };

        reader.readAsDataURL(file);
      }
    }
  };

  const onSubmit = async (data) => {
    if (data.proof_of_consent === "")
      return alert("Please upload proof of consent.");

    // Submit form
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/workstation/add_consent`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ candidate_id, ...data }),
        },
      );

      const result = await response.json();
      console.log(result);
      toastr.success(result.message);
      onClose(1);
    } catch (error) {
      toastr.error(error);
    }
  };

  return (
    <div className="modal fade show d-block" tabIndex="-1">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="modal-header">
              <h5 className="modal-title">Candidate Consent Required</h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
              ></button>
            </div>

            <div className="modal-body">
              <p className="mb-2">
                Consent has not been received from the candidate to store their
                information. Please remind them to check their emails and
                provide consent or paste a screenshot of them sharing their
                resume here.
              </p>

              <select
                className={`form-select mb-3 ${errors.status ? "is-invalid" : ""}`}
                {...register("status", { required: true })}
              >
                <option value="">Select Consent Status</option>
                <option value="approved">Approved</option>
                <option value="rejected">Rejected</option>
              </select>
              {/* Paste Only Box */}
              <div
                ref={pasteRef}
                onPaste={handlePaste}
                tabIndex="0" // IMPORTANT: makes div focusable
                className="border border-2 border-dashed rounded p-4 text-center"
                style={{ minHeight: "150px", outline: "none" }}
              >
                <input type="hidden" {...register("proof_of_consent")} />
                {image ? (
                  <img
                    src={image}
                    alt="Screenshot Preview"
                    className="img-fluid rounded"
                  />
                ) : (
                  <p className="mb-0">
                    📸 Click here and press <strong>Ctrl + V</strong> to paste
                    screenshot
                  </p>
                )}
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={onClose}
              >
                Close
              </button>
              <button type="submit" className="btn btn-primary ms-2">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ConsentModal;
